import React, { useCallback, useEffect, useState } from "react";
import { SmartSoftButton, SmartSoftTable, SmartTable, SmartTableNewInterface } from "soft_digi";
import { useSiteContext } from "../../contexts/SiteProvider";
import { showNotification, showYesOrNoAlert } from "../../services/notifyService";
import { get, post } from "../../services/smartApiService";
import { PROJECT_URLS } from "../../api/ProjectsUrls";
import CreateProject from "./CreateProject";


const sampleData =[
  {
    project_name: "test",
    roles: "test",
    created_task:"23",
    published_task:"3"
  },
  {
    project_name: "test",
    roles: "test",
    created_task:"23",
    published_task:"3"
  },
  {
    project_name: "test",
    roles: "test",
    created_task:"23",
    published_task:"3"
  }
]

const ProjectTable = () => {
  const [data, setData] = useState<any[]>([]);
  const [getTask, setGetTask] = useState([]);
  const [path, setPath] = useState("projects");

  const { setLoading, openModal } = useSiteContext();
  
  const loadTableData = useCallback((purpose = "") => {
    setGetTask([])
    // return setData(sampleData)
    setLoading(true, purpose && purpose + "ing...");
    const subscription = get(PROJECT_URLS.GET_ALL).subscribe((response) => {
      setData(response.data.data);
        purpose 
        ? setTimeout(() => setLoading(false), 800)
        : setLoading(false);
      });
    return () => subscription.unsubscribe();
  },[]);

  useEffect(() => {
    loadTableData();
    setGetTask([])
  },[]);

  const getValue = (value: string) =>{
    const val = !value || value.length < 1 ? <div className="pl-6">-</div> : value;
    return val
  }
  
  const goTaskTable = (obj: any) =>{
    let id = obj['ID'];
    let project_name = obj['project_name'];
    let created_task = obj['created_task'];
    let published_task = obj['published_task'];

    if(created_task<1 && published_task<1) return showNotification("error", "No Datas" );
    setLoading(true);
    const subscription = post(PROJECT_URLS.GET_TASK_BY_PROJ,{id:id}).subscribe((response) => {
      setLoading(false);
      openTasksModal(response.data.data,project_name)
      // setPath("tasktable")
      setGetTask(response.data.data);
    }); 
    return () => subscription.unsubscribe();
  }

  const openTasksModal = (dataIn: any, proj_name: string) =>{
    let modalObject ={
      title: proj_name,  
      // title: dataIn?.project_name ?? "Task",
      // content:<TaskTable dataIn={dataIn}/>,
      bodyClose: false,
      modalClass: "smart-modal-80",
    }
    openModal(modalObject)
  }

  const editProject = (id: string) => {
    setLoading(true);
   const subscription = post(PROJECT_URLS.GET_ONE, { id: id }).subscribe((response) => {
     setLoading(false);
     openEditModal(response.data.data);
   });
   return () => subscription.unsubscribe();
 };

 const openEditModal = (data_in: any) => {
  let modalObject = {
    title: "PROJECT MODIFICATION",
    content:<CreateProject dataIn={data_in} loadTableData={loadTableData}/>,
    bodyClose: false,
    modalClass: "smart-modal-70",
  };
  openModal(modalObject);
};


const deteleProject = (obj: any) => {
  showYesOrNoAlert(`Do you want to Delete "${obj["project_name"]}" Project?`, (result: string) => {
    if (result == "yes") {
      send_delete_request(obj);
    }},"question");    
};

const send_delete_request = (obj: any) =>{
setLoading(true,"Deleting...");
  const subscription = post(PROJECT_URLS.DELETE, { id: obj["ID"] }).subscribe((response) => {
      setLoading(false);
      showNotification("success",`${obj["project_name"]} Project Deleted Successfully`);
      loadTableData();
    }
  );
  return () => subscription.unsubscribe();
}
  
  const alltasks = (obj: any) =>{
    let created_task = obj["created_task"];
    let published_task = obj["published_task"];

    return(
      <>
        <span className="smart-cursor" >{created_task+", "}</span>
        <span className="ml-1 has-text-success">({published_task})</span>
      </>
    )
  } 

  const getRoles=(obj: any)=>{
    const roles = obj["roles"];
    if(roles.length < 1) return <div className="pl-5">-</div>
    if(!Array.isArray(roles)) return roles;
    return roles.join(", ");
  }

  const more_details= (obj: any)=>{
    return (
      <>
        {/* <SmartSoftButton label="More" onClick={()=>goTaskTable(obj)} classList={["button is-small is-link is-rounded"]}/> */}
        <span className="icon" onClick={()=>goTaskTable(obj)}>
          <i className="fa fa-angle-up"></i>
        </span>
      </>
    )
  }

 const actionButtons= [
  {
    leftIcon: "fa-pencil", 
    type:"icon",
    classList:["has-text-link"],      
    onClick:(row:any)=> editProject(row["ID"])
  },
  {
    leftIcon: "fa-trash", 
    type:"icon",
    classList:["has-text-danger"],      
    onClick:(row:any)=> deteleProject(row)
  },
]

  const columns:SmartTableNewInterface.SmartTableNewColumnConfig[] = [
    { title: "S.NO", index: "s_no", type: "sno", width: "5" },
    { title: "PROJECT TITLE", index: "project_name", valueFunction: (obj: any)=>getValue(obj["project_name"])},
    { title: "ROLES", index: "roles", valueFunction: getRoles},
    { title: "TASKS", index: "tasks", valueFunction: alltasks},
    // { title: "DETAILS", index: "", valueFunction: more_details, classHead:"has-text-centered", classBody:"has-text-centered"},
    { title: "", index: "action", type:"action", width: "5", buttons:actionButtons },
  ];

  const projectcreation = ()=>{
    let modalObject={
      title:"PROJECT CREATION",
      content:<CreateProject loadTableData={loadTableData}/>,
      bodyClose: false,
      modalClass: "smart-modal-70"
    } 
    openModal(modalObject)
  }


  const tableTop: SmartTableNewInterface.SmartTableNewTopProps[] = [
    {
      type: "CUSTOM",
      widthClass: "is-4",
      custom: <p className="has-text-link is-size-4">Projects</p>,
     
    },
    {
      type: "BUTTONS",
      widthClass: "is-2",
      align: "CENTER",
      buttons: [       
        {
          type: "REFRESH",
          action:()=>loadTableData()          
        },    
      ],      
    },
    {
      type: "SEARCH",
      widthClass: "is-4",
      align: "RIGHT",
    },
    
    {
      type: "CUSTOM",
      widthClass: "is-2",
      align:"RIGHT",
      custom: 
        <div className="buttons mx-3">
          <SmartSoftButton 
            label="New Project" 
            onClick={()=>projectcreation()} 
            leftIcon="fa-plus"           
            classList={["smart-third-button"]}         
          />        
        </div>
    },
  ]

  const getByTitle=()=>{
    switch(path){
      case "tasktable":
        // return getTask?.project_name
      case "createproject":
        return "PROJECT CREATION"
    }
  }  

  const display_table = () =>(
    <div>
      <div className="shadow my-4">
       <SmartTable
          tableTop={tableTop}
          columns={columns}
          data={data}
          tableProps={{
            className: "table is-hoverable is-striped smart-pdf-table",
            isResponsive: true,
            searchIndexes: ["project_name", "roles"],
            searchPlaceHolder: "Search",
          }} 
      />
      </div>
    </div>
  )

  return (
    <>
    {path=="projects" && display_table()}
    {/* <SmartHeadBack title={getByTitle()} path={path} setPath={setPath} backnav="projects"/> */}
    </>
  );
};

export default ProjectTable;
